import { useTranslation } from 'react-i18next';
import { fetchGallery } from '../lib/api';
import { useSupabaseData } from '../lib/useSupabaseData';
import PhotoGallery from '../components/PhotoGallery';
import { Reveal, RevealHeading } from '../components/Reveal';

// Zdjęcia zapasowe (gdy baza jest niedostępna) — te z oryginalnego wydania strony
import img1 from '../assets/Galeria/0-58.jpeg';
import img2 from '../assets/Galeria/0-55.jpeg';
import img3 from '../assets/Galeria/0-48.jpeg';
import img4 from '../assets/Galeria/0-47.jpeg';
import img5 from '../assets/Galeria/0-43.jpeg';
import img6 from '../assets/Galeria/0-38.jpeg';
import img7 from '../assets/Galeria/0-27.jpeg';
import img8 from '../assets/Galeria/0-26.jpeg';
import img9 from '../assets/Galeria/0-24.jpeg';
import img10 from '../assets/Galeria/0-23.jpeg';
import img11 from '../assets/Galeria/0-18.jpeg';
import img12 from '../assets/Galeria/unnamed.jpg';
import img13 from '../assets/Galeria/0-15.jpeg';
import img14 from '../assets/Galeria/0-14.jpeg';
import img15 from '../assets/Galeria/0-13.jpeg';
import img16 from '../assets/Galeria/0-12.jpeg';
import img17 from '../assets/Galeria/0-11.jpeg';
import img18 from '../assets/Galeria/0-9.jpeg';
import img19 from '../assets/Galeria/0.jpeg';
import img20 from '../assets/Galeria/IMG_7896.jpeg';
import img21 from '../assets/Galeria/IMG_5338.jpg';
import img22 from '../assets/Galeria/IMG_5356.jpg';
import img23 from '../assets/Galeria/IMG_7573.jpg';
import newImg1 from '../assets/Nasze zdjęcia/Nasze zdjęcia/049a231d-94dc-4edd-aa34-e85afe0254df.JPG';
import newImg2 from '../assets/Nasze zdjęcia/Nasze zdjęcia/23464d7c-3a3f-41dd-8baf-0be028c4db45.jpg';
import newImg3 from '../assets/Nasze zdjęcia/Nasze zdjęcia/2dc33082-d397-4b3b-83f4-f4989ca27fac.JPG';
import newImg4 from '../assets/Nasze zdjęcia/Nasze zdjęcia/395674830_538467075148101_1169534624602934557_n.jpg';
import newImg5 from '../assets/Nasze zdjęcia/Nasze zdjęcia/4d8193f7-c4c0-4229-b731-1ae38776acf8.jpg';
import newImg6 from '../assets/Nasze zdjęcia/Nasze zdjęcia/4f3363e4-0808-47cc-aa46-25384bd7e166.JPG';
import newImg7 from '../assets/Nasze zdjęcia/Nasze zdjęcia/62aad37b-3f1a-4019-b7cf-93688bfe8e5b.JPG';
import newImg8 from '../assets/Nasze zdjęcia/Nasze zdjęcia/67c098b1-d375-4dec-91be-80383b909425.jpg';
import newImg9 from '../assets/Nasze zdjęcia/Nasze zdjęcia/9acbb8b9-0fb1-47d0-bcaf-7a838762424d.JPG';
import newImg10 from '../assets/Nasze zdjęcia/Nasze zdjęcia/IMG_0096.JPG';
import newImg11 from '../assets/Nasze zdjęcia/Nasze zdjęcia/IMG_3687.jpg';
import newImg12 from '../assets/Nasze zdjęcia/Nasze zdjęcia/IMG_4479.jpg';
import newImg13 from '../assets/Nasze zdjęcia/Nasze zdjęcia/IMG_9350.jpg';
import newImg14 from '../assets/Nasze zdjęcia/Nasze zdjęcia/Kopia pliku IMG_0601.jpeg';
import newImg15 from '../assets/Nasze zdjęcia/Nasze zdjęcia/Kopia pliku IMG_8141.jpeg';
import newImg16 from '../assets/Nasze zdjęcia/Nasze zdjęcia/Kopia pliku ORUNIA_0141.jpg';
import newImg17 from '../assets/Nasze zdjęcia/Nasze zdjęcia/P1393725.JPG';
import newImg18 from '../assets/Nasze zdjęcia/Nasze zdjęcia/bace7f47-09df-479b-986b-c2814b71dc34.JPG';

const staticGallery = [
  img1, img2, img3, img4, img5, img6, img7, img8, img9, img10,
  img11, img12, img13, img14, img15, img16, img17, img18, img19, img20,
  img21, img22, img23,
  newImg1, newImg2, newImg3, newImg4, newImg5, newImg6, newImg7, newImg8, newImg9, newImg10,
  newImg11, newImg12, newImg13, newImg14, newImg15, newImg16, newImg17, newImg18,
];

const fetchGalleryItems = async () => {
  const items = await fetchGallery();
  return items.map((it) => ({ url: it.url, caption: it.caption || '' }));
};

const GalleryPage = () => {
  const { t } = useTranslation();
  const { data: images } = useSupabaseData(fetchGalleryItems, staticGallery, 'gallery');

  return (
    <div className="animate-fadeIn">
      <section className="my-12 md:my-20 text-center">
        <RevealHeading as="h1" text={t('gallery.title')} className="text-4xl md:text-5xl text-brand-accent" />
        <Reveal as="p" delay={0.18} className="mx-auto mt-4 max-w-2xl text-lg text-brand-text-light/75">
          {t('gallery.subtitle')}
        </Reveal>
        <Reveal as="p" delay={0.3} y={12} className="mt-3 text-xs uppercase tracking-[0.25em] text-brand-text-light/40">
          {images.length} {t('gallery.photos_count')}
        </Reveal>
      </section>

      <PhotoGallery images={images} alt={t('gallery.title')} layout="masonry" thumbWidth={600} />
    </div>
  );
};

export default GalleryPage;
